import List from './views/index.c';

export default List;
